import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../components/Header';
import Separator from '../components/Separator';
import FeaturedSolutions, { FeaturedItem } from '../components/FeaturedSolutions';
import laptopEatecCatering from '../assets/products/laptop-eatec-catering.png';

const HallPage = () => {
  const navigate = useNavigate();

  return (
    <div className="page hallPage">
      <Header />
      <div className="page-header">Golf Course</div>

      <div className="text-wrapper">
        <div className="top">
          <div className="topic-header">Event Hall</div>
          <Separator />
        </div>
        <div className="std-text">
          {"Make every meeting, social event, ceremony or fundraiser unforgettable with Agilysys Eatec inventory & procurement management. With robust recipe and nutritional information management and a built-in banquet catering module, attendees will be guaranteed a truly memorable experience."}
        </div>
      </div>

      <FeaturedSolutions>
        <FeaturedItem
          label="Eatec"
          imgSrc={laptopEatecCatering}
          onClick={() => navigate('/solutions/eatec')}
        />
      </FeaturedSolutions>
    </div>
  );
};

export default HallPage;
